import { render, staticRenderFns } from "./FHQXPage.vue?vue&type=template&id=a91f8ce4&scoped=true"
import script from "./FHQXPage.vue?vue&type=script&lang=js"
export * from "./FHQXPage.vue?vue&type=script&lang=js"
import style0 from "./FHQXPage.vue?vue&type=style&index=0&id=a91f8ce4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91f8ce4",
  null
  
)

export default component.exports